export default [
  {
    path: '/data',
    name: 'data',
    component: () => import('@/pages'),
    redirect: '/data/quality',
    meta: { title: '数据中心', icon: 'pie-chart' },
    children: [
      {
        path: 'quality',
        name: 'qualityData',
        component: () => import('@/pages/data/quality'),
        meta: { title: '质量数据', icon: 'bar-chart', parent: 'data' }
      },
      {
        path: 'diagram',
        name: 'diagramData',
        component: () => import('@/pages/data/diagram'),
        meta: { title: '测试', icon: 'bar-chart', parent: 'data' }
      }
    ]
  }
];
